import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

// tab顺序，完整的顺序为开始、插入、美化、切换（未实现）、动画、放映、审阅（未实现）、批注、视图、效率工具、选中元素后的活动tab（未实现）
export const FIXED_KEYS_DOUBLE = {
    TOOLBAR_START: 'toolbar-start',
    TOOLBAR_INSERT: 'toolbar-insert',
    TOOLBAR_BEAUTIFY: 'toolbar-beautify',
    TOOLBAR_TRANSITION: 'toolbar-transition',
    TOOLBAR_ANIM: 'toolbar-anim',
    TOOLBAR_PLAY: 'toolbar-play',
    TOOLBAR_COMMENT: 'toolbar-comment',
    TOOLBAR_VIEW: 'toolbar-view',
    TOOLBAR_EFFICIENCY: 'toolbar-efficiency',
    TOOLBAR_TABLE: 'toolbar-table',
    TOOLBAR_TABLE_POSITION: 'toolbar-table-position',
    TOOLBAR_VIP: 'toolbar-vip',
    TOOLBAR_PICTURE: 'toolbar-picture',
    TOOLBAR_SHAPE: 'toolbar-shape',
    TOOLBAR_MACHINE_AUDIT: 'toolbar-machine-audit', // 机器审核，只有模版制作者才会出现
};
export const FIXED_KEYS_SINGLE = 'toolbar-simple';


export const ELEMENT_TAB_MAP = {
    [UIModelType.SHAPE]: [FIXED_KEYS_DOUBLE.TOOLBAR_SHAPE],
    [UIModelType.CONNECTOR]: [FIXED_KEYS_DOUBLE.TOOLBAR_SHAPE],
    [UIModelType.IMAGE]: [FIXED_KEYS_DOUBLE.TOOLBAR_PICTURE],
    [UIModelType.TABLE]: [FIXED_KEYS_DOUBLE.TOOLBAR_TABLE, FIXED_KEYS_DOUBLE.TOOLBAR_TABLE_POSITION],
};
